import { Box } from '@mui/system';
import * as React from 'react';

type FillerProps = React.PropsWithChildren<{}>;
export const Filler = (props: FillerProps) => {
  return <Box flexGrow={1}>{props.children}</Box>;
};
